import axios from 'axios'
import { toast } from 'react-toastify'

const api = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL
})

api.interceptors.response.use(
    response => response.data,
    err => new Promise((_, reject) => reject(err.response?.data))
)

api.interceptors.request.use(
    config => {
        if (!navigator.onLine) {
            toast.error('Verifique sua conexão com a internet.')

            return Promise.reject({
                message: 'Sem conexão com a internet',
                is_offline: true
            })
        }

        return config
    },
    e => {
        return Promise.reject(e)
    }
)

const authHeaders = () => {
    let token

    while (!token) {
        token = sessionStorage.getItem(process.env.REACT_APP_SESSION_STORAGE_TOKEN)
    }

    return {
        headers: { Authorization: `Bearer ${token}` }
    }
}

const apiLegado = axios.create({
    baseURL: process.env.REACT_APP_API_LEGADA_URL || 'http://localhost/legado',
    responseType: 'blob'
})

const apiLegadoCarga = axios.create({
    baseURL: process.env.REACT_APP_API_LEGADA_URL || 'http://localhost/legado'
})

export {
    authHeaders,
    api,
    apiLegado,
    apiLegadoCarga
}
